export default __webpack_public_path__ + "static/media/65207733_2219495894806488_6123305066834165760_n.fd57575c.jpg";